import { createSelector } from "@reduxjs/toolkit";
import { checkedTypes } from "constants/types";
import { get } from "lodash";

export const selectDictionarySearchState = (state) => state.dictionarySearch;

export const selectFolderState = createSelector(
  [selectDictionarySearchState],
  (dictionarySearch) => dictionarySearch.folder
);

export const selectFolderDictionaryCategories = createSelector(
  [selectFolderState],
  (folder) => folder?.dictionary?.categories || []
);

export const selectDefaultDocuments = createSelector(
  [selectDictionarySearchState],
  (dictionarySearch) => dictionarySearch.documents || []
);

export const selectDictionarySearchConfig = createSelector(
  [selectDictionarySearchState],
  (dictionarySearch) => dictionarySearch.config
);

export const selectConfigLoading = createSelector(
  [selectDictionarySearchConfig],
  (config) => config.loading
);

export const selectConfigFolderBy = createSelector(
  [selectDictionarySearchConfig],
  (config) => config.folderBy
);

export const selectConfigFolderId = createSelector(
  [selectDictionarySearchConfig],
  (config) => config.folderId
);

export const selectCurrentDocuments = createSelector(
  [selectConfigFolderBy, selectDefaultDocuments, selectFolderState],
  (by, documents, folder) => {
    const isFolder = by === "folder";

    return (isFolder ? folder?.documents : documents) || [];
  }
);

export const selectSelectedDocuments = createSelector(
  [selectCurrentDocuments],
  (documents) => {
    return documents.filter(
      ({ checkState }) => checkState !== checkedTypes.EMPTY
    );
  }
);

export const selectSelectedTermInstances = createSelector(
  [
    selectConfigFolderBy,
    selectFolderDictionaryCategories,
    selectDefaultDocuments,
  ],
  (by, folderCategories, documents) => {
    const isFolder = by === "folder";
    let categories = [];

    // Flatten all categories based on Current view
    categories = isFolder
      ? folderCategories
      : documents.reduce(
          (acc, doc) => acc.concat(get(doc, ["dictionary", "categories"], [])),
          []
        );

    let selectedTermIds = [];
    let totalOccurances = 0;

    for (const category of categories) {
      const { items = [], occurrences } = category;
      totalOccurances += occurrences ?? 0;

      for (const item of items) {
        if (item.checkState === checkedTypes.CHECKED) {
          selectedTermIds.push(item.id);
        }
      }
    }

    return [selectedTermIds, totalOccurances];
  }
);
